$(document).ready(function() {

    // Add active state to desktop navbutton
    $('.nav__button').click(function(e) {
        e.stopPropagation();

        $(this).toggleClass('nav__button--active');
        $('.innerbody').toggleClass('body--fixed');


        // $('.menu-primary-menu-container').toggleClass('menu-primary-menu-container--active');
        if($('.menu-primary-menu-container').hasClass('menu-primary-menu-container--active')) {

            $('.menu-primary-menu-container').removeClass('menu-primary-menu-container--active-transition');
            setTimeout(function() {
                $('.menu-primary-menu-container').removeClass('menu-primary-menu-container--active');
            }, 250)
        } else {
            $('.menu-primary-menu-container').addClass('menu-primary-menu-container--active');
            $('.menu-primary-menu-container').addClass('menu-primary-menu-container--active-transition');

        }

    });



    // Add dropdown arrows to mobile nav
    $('.menu-item-has-children > a').append('<span></span>');

    // Show/Hide Sub Menus for mobile nav
    $('.menu-item-has-children > a > span').click(function(e) {
        e.preventDefault();
        e.stopPropagation();

        $(this).toggleClass('dropdown_arrow--active');
        $(this).closest('.menu-item-has-children').toggleClass('sub-menu--active');

    });


    $('body').click(function() {


        if($('.nav__button').hasClass('nav__button--active')) {
            $('.nav__button').removeClass('nav__button--active');
        }
        if($('.innerbody').hasClass('body--fixed')) {
            $('.innerbody').removeClass('body--fixed');
        }

        // If menu active and you click outside menu, close menu
        if($('.menu-primary-menu-container').hasClass('menu-primary-menu-container--active')) {
            $('.menu-primary-menu-container').removeClass('menu-primary-menu-container--active-transition');
            setTimeout(function() {
                $('.menu-primary-menu-container').removeClass('menu-primary-menu-container--active');
            }, 250)
        }

    });


});


// WEBPACK FOOTER //
// ./nav.js